var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowE = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 8,
  viewBox: "0 0 10 8",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m6 0 3.654 3.321a.897.897 0 0 1 0 1.358L6 8h-.508a.99.99 0 0 1-.993-.992V6.5L6.634 5H0V3h6.634L4.5 1.5V.992C4.5.444 4.942 0 5.493 0z"
})));
export default SvgArrowE;